import { render, staticRenderFns } from "./applyDetails.vue?vue&type=template&id=65317432&scoped=true"
import script from "./applyDetails.vue?vue&type=script&lang=js"
export * from "./applyDetails.vue?vue&type=script&lang=js"
import style0 from "./applyDetails.vue?vue&type=style&index=0&id=65317432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65317432",
  null
  
)

export default component.exports